import { render } from "./administrarBase.vue?vue&type=template&id=75362758&scoped=true"
import script from "./administrarBase.vue?vue&type=script&lang=js"
export * from "./administrarBase.vue?vue&type=script&lang=js"

import "./administrarBase.vue?vue&type=style&index=0&id=75362758&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75362758"]])

export default __exports__